import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardHeader, MDBCardBody, MDBCardTitle, MDBBtn, MDBCardText } from 'mdb-react-ui-kit'
import React from 'react'

export function WhatWeDo() {

    return (
        <>
            <MDBContainer className={'border border-0 border-danger'}>
                <MDBRow center>
                    <MDBCol lg={'6'}>
                        <MDBCard className={'shadow-5 mb-5'}>
                            <MDBCardHeader>WHAT WE DO</MDBCardHeader>
                            <MDBCardBody className={'text-center fw-light'}>
                                {/* <MDBCardTitle>Special title treatment</MDBCardTitle>
                                <MDBCardText>With supporting text below as a natural lead-in to additional content.</MDBCardText>
                                <MDBBtn href='#'>Go somewhere</MDBBtn> */}
                                NUS Network Ghana, is a research and development organization that promotes neglected and
                                underutilized crop species (NUS), also known as orphan crops, opportunity crops, indigenous crops or
                                traditional crops, through the conservation of their genetic resources, development of improved
                                varieties and upgrading of their value chains. We also provide technical advice on production, offer
                                training and engage in production of NUS crops/opportunity crops of Africa.
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </>
    )
}